import SmsIcon from 'components/atoms/icons/smsIcon';
import { useMemo } from 'react';
import { isPractice } from 'utils/userTypeHelper';

const useSmsButtons = ({
  doctor,
  setSmsPopupOpen,
  setDoctorSmsPopupOpen,
  userType,
}) => {
  const smsButtons = useMemo(
    () => [
      {
        render: true,
        label: 'SMS Patient',
        icon: SmsIcon,
        handleClick: () => setSmsPopupOpen(true),
      },
      {
        render: doctor.mobileNumber && !isPractice(userType),
        label: 'SMS Primary Doctor',
        icon: SmsIcon,
        handleClick: () => setDoctorSmsPopupOpen(true),
      },
    ],
    [doctor, setSmsPopupOpen, setDoctorSmsPopupOpen, userType],
  );

  return smsButtons;
};

export default useSmsButtons;
